import { useState } from 'react'

const hasHoverSupport = () =>
  typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover: hover)').matches

// Props for a NavDropdown that opens on hover on devices with a pointer, and on click otherwise
const useHoverDropdown = () => {
  const [show, setShow] = useState(false)
  const hover = hasHoverSupport()

  return {
    show,
    onToggle: (nextShow) => setShow(nextShow),
    onMouseEnter: hover ? () => setShow(true) : undefined,
    onMouseLeave: hover ? () => setShow(false) : undefined
  }
}

export default useHoverDropdown
